import { useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useGovernance } from "@/hooks/useGovernance";
import { TorForm } from "@/components/governance/TorForm";
import { useToast } from "@/hooks/use-toast";

export default function TorEditor() {
  const navigate = useNavigate();
  const { committeeId } = useParams();
  const { toast } = useToast();
  const { committees, terms, members, getMemberById, saveTorDraft, submitTorForApproval } = useGovernance();

  const committee = useMemo(
    () => committees.find((item) => item.id === committeeId),
    [committees, committeeId],
  );
  const tor = useMemo(() => terms.find((item) => item.committeeId === committeeId), [terms, committeeId]);

  if (!committee || !tor) {
    return (
      <Card className="shadow-card">
        <CardContent className="py-16 text-center text-muted-foreground">
          ToR not found for this committee yet.
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-6">
      <div className="space-y-1">
        <h1 className="text-3xl font-medium text-foreground">Manage Terms of Reference</h1>
        <p className="text-muted-foreground">
          Committee: {committee.name}
        </p>
      </div>

      <Card className="shadow-card">
        <CardHeader>
          <CardTitle>ToR Details</CardTitle>
        </CardHeader>
        <CardContent>
          <TorForm
            committee={committee}
            tor={tor}
            members={members}
            ownerName={getMemberById(committee.ownerId)?.name ?? "Unassigned"}
            onChange={(patch) => saveTorDraft(tor.id, patch)}
            onSaveDraft={() => {
              saveTorDraft(tor.id, {});
              toast({ title: "Draft Saved", description: "Terms of Reference draft has been saved." });
            }}
            onSubmitForApproval={() => {
              submitTorForApproval(tor.id);
              toast({ title: "Submitted", description: "ToR has been submitted for approval." });
            }}
            onPreview={() => navigate(`/governance/tor/${committee.id}/preview`)}
          />
        </CardContent>
      </Card>
    </div>
  );
}
